import { SortOrder } from '@/enums';
import { axiosClient } from '@/hooks';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchCells = createAsyncThunk(
  'cells/fetchCells',
  async (
    {
      page,
      limit,
      orderBy,
      sortOrder,
      search
    }: {
      page: number;
      limit: number;
      orderBy?: string;
      sortOrder?: SortOrder;
      search?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosClient.get(`/cells`, {
        params: {
          page,
          limit,
          ...(orderBy && { orderBy }),
          ...(sortOrder && { sortOrder }),
          ...(search && { search })
        }
      });
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchCellsBySector = createAsyncThunk(
  'cells/fetchCellsBySector',
  async (sectorId: string, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`/sectors/${sectorId}/cells`);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
